export default "__VITE_ASSET__sDrvaQ12__"